import { ATSInviteToApplyTestIds } from 'data-testids/ATS';
import { Box, useTheme } from '@mui/material';
import { Key, Row, SuccessSubContainer } from '../styles/hiringRequestStyles';
import { ModalContainer, Title } from '../styles/styles';
import { Alert } from 'sharedComponents/Alert';
import { PrimaryButton } from 'sharedComponents/Buttons';
import { primaryButtonOverrideSx } from 'sharedComponents/Buttons/styles';

export interface InviteToApplySuccessPageProps {
  candidateName: string;
  candidateEmail: string;
  roleTitle: string;
  locationText: string;
  contactMethods?: string[];
  onClose: () => void;
}

export const InviteToApplySuccessPage: React.FC<InviteToApplySuccessPageProps> = ({
  candidateName,
  candidateEmail,
  roleTitle,
  locationText,
  contactMethods,
  onClose,
}) => {
  const theme = useTheme();

  return (
    <Box sx={{ width: '100%' }}>
      <ModalContainer>
        <Title
          sx={{ color: theme.palette.success.main }}
          data-testid={ATSInviteToApplyTestIds.SUCCESS_TITLE}
        >
          You have invited {candidateName} to apply!
        </Title>

        <SuccessSubContainer>
          <Key>Invite Details</Key>
        </SuccessSubContainer>

        <SuccessSubContainer>
          <Row data-testid={ATSInviteToApplyTestIds.SUCCESS_CANDIDATE_NAME}>
            <Key>Candidate:</Key> &nbsp;{candidateName}
          </Row>
          <Row data-testid={ATSInviteToApplyTestIds.SUCCESS_CANDIDATE_EMAIL}>
            <Key>Candidate Email:</Key> &nbsp; {candidateEmail}
          </Row>
          <Row data-testid={ATSInviteToApplyTestIds.SUCCESS_ROLE_TITLE}>
            <Key>Role:</Key> &nbsp;{roleTitle}
          </Row>
          <Row data-testid={ATSInviteToApplyTestIds.SUCCESS_ROLE_LOCATION}>
            <Key>Location:</Key> &nbsp;{locationText}
          </Row>
          <Row data-testid={ATSInviteToApplyTestIds.SUCCESS_CONTACT_METHODS}>
            <Key>Contact Method(s):</Key> &nbsp; {contactMethods?.join(', ')}
          </Row>
        </SuccessSubContainer>

        <SuccessSubContainer data-testid={ATSInviteToApplyTestIds.SUCCESS_NEXT_STEPS}>
          <Alert icon={false} sx={{ color: theme.palette.text.primary }}>
            <Key>Here&apos;s what&apos;s next: &nbsp;</Key>
            <ol style={{ paddingLeft: '20px', listStyleType: 'decimal' }}>
              <li>We&apos;ve sent {candidateName} an email inviting them to apply to this role.</li>
              <li>Once they submit their application, it will be available for review.</li>
            </ol>
          </Alert>
        </SuccessSubContainer>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <PrimaryButton
            onClick={onClose}
            sx={{
              ...primaryButtonOverrideSx(theme),
              boxShadow: 0,
              fontSize: theme.typography.body2.fontSize,
              letterSpacing: '0.2px',
            }}
          >
            Done
          </PrimaryButton>
        </Box>
      </ModalContainer>
    </Box>
  );
};
